import { render, staticRenderFns } from "./detectionWindowPeriod.vue?vue&type=template&id=93998ece"
import script from "./detectionWindowPeriod.vue?vue&type=script&lang=js"
export * from "./detectionWindowPeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93998ece')) {
      api.createRecord('93998ece', component.options)
    } else {
      api.reload('93998ece', component.options)
    }
    module.hot.accept("./detectionWindowPeriod.vue?vue&type=template&id=93998ece", function () {
      api.rerender('93998ece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Nutrition/baseData/detectionWindowPeriod.vue"
export default component.exports